import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PETITION_PAGE_CONTACT_DM = defineFcm('petition_page_contact_dm')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			optional: true,
			shape: {
				emailEnabled: { type: 'boolean' },
				phoneEnabled: { type: 'boolean' },
				emailSubjectLine: { type: 'string', optional: true },
				emailBody: { type: 'array', optional: true, shape: { type: 'string' } },
			},
		}),
	)
	.withDefault({
		emailEnabled: false,
		phoneEnabled: false,
		emailSubjectLine: '',
		emailBody: [],
	})
	.toConfig();
